$(document).ready(function() {


  //product variant swap
  if($('.template-product').length > 0){
 
  }
  
  //hero slier 
  $('.slick-slider-hero').slick({
      dots: true,
      infinite: true,
      speed: 200,
      fade: false,
      cssEase: 'linear',
      arrows: false
  });

 
  if($('.input-fieldset__values').length >0){
    $('.input-fieldset__values').change(function(){

      var el = $('.input-fieldset__values').first().find('input[type=radio]:checked').val();

      $('#gallery-wrap').find('img').each(function(){
        var ex = $(this).attr('alt');
        if(ex == 'lifestyle') {
          $(this).closest('li').removeClass('hidden');
        } else {
          if(ex != el) {
            $(this).closest('li').addClass('hidden');
          } else {
            $(this).closest('li').removeClass('hidden');
          }
        } 
      })

      $('#gallery-scroll-bar').find('img').each(function(){
        var ex = $(this).attr('alt');
        if(ex == 'lifestyle') {   
          $(this).closest('li').removeClass('hidden');
        } else {
          if(ex != el) {
            $(this).closest('li').addClass('hidden');
          } else {
            $(this).closest('li').removeClass('hidden');
          }
        } 
      })
      
      $('.product-gallery-modal').first().find('.product-gallery-modal__media-item img').each(function(){
        var ex = $(this).attr('alt');
         
        if(ex == 'lifestyle') {
          $(this).closest('li').removeClass('hidden');
        } else {
          if(ex != el) {
            $(this).closest('li').addClass('hidden');
          } else {
            $(this).closest('li').removeClass('hidden');
          }
        } 
      })
     
    }) 
  }

  setTimeout(function(){
    var el = $('.input-fieldset__values').first().find('input[type=radio]:checked').val();
    
      $('#gallery-wrap').find('img').each(function(){
        var ex = $(this).attr('alt');
        if(ex == 'lifestyle') {
          $(this).closest('li').removeClass('hidden');
        } else {
          if(ex != el) {
            $(this).closest('li').addClass('hidden');
          } else {
            $(this).closest('li').removeClass('hidden');
          }
        } 
      })

      $('#gallery-scroll-bar').find('img').each(function(){
        var ex = $(this).attr('alt');
        if(ex == 'lifestyle') {   
          $(this).closest('li').removeClass('hidden');
        } else {
          if(ex != el) {
            $(this).closest('li').addClass('hidden');
          } else {
            $(this).closest('li').removeClass('hidden');
          }
        } 
      })

     $('.product-gallery-modal').first().find('.product-gallery-modal__media-item img').each(function(){
        var ex = $(this).attr('alt');
        if(ex == 'lifestyle') {
          $(this).closest('li').removeClass('hidden');
        } else {
          if(ex != el) {
            $(this).closest('li').addClass('hidden');
          } else {
            $(this).closest('li').removeClass('hidden');
          }
        } 
      })

      //update lead times
      getVariantLead();

  },2000)
  

  //delegate the lightbox click
  $('#swatch-link').click(function(e){
    e.preventDefault();
    $('#lightbox-swatch-wrapper').find('a').first().click();
  })

  $(document).on('change', '.input-radio__input', function() {
   getVariantLead();
  });

  $(document).on('click', '.option-selectable-boxes div', function() {
   getVariantLead();
  });

  $(document).on('change', '.input-swatch__input', function() {
   getVariantLead();
  });

  /*
  $('.input-radio__input').change(function(){
    getVariantLead();
  });

  $('.option-selectable-boxes div').click(function(){
    getVariantLead();
  });

  $('.input-swatch__input').change(function(){
   getVariantLead();
  })
  */

  function getVariantLead(){
    let cVariant = $('.variant-selector__variants').val();
    $('.leadtime').addClass('hidden');
    $('#lead-' + cVariant).removeClass('hidden');
  };
  
  //hero slider 
  $('#shop-the-look-slider').slick({
      dots: false,
      infinite: true,
      speed: 900,
      fade: true,
      cssEase: 'linear',
      arrows: true
  });

  $('.input-swatch img').click(function(){
     $(this).closest('.input-swatch').find('.input-swatch__input').first().click();
  })
  
  //collection slick slider 
  $('.slick-slider-collections').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]  
  });


  //delegated slider clicks
  $('.product-slider-button.slick-prev').click(function(){
    $(this).closest('section').find('#collection-prev-button').click();
  });
  
  $('.product-slider-button.slick-next').click(function(){
     $(this).closest('section').find('#collection-next-button').click();
  });
  
    //FAQ toggles

    $('.Faq__Question').click(function(e) {
      e.preventDefault();
      $(this).closest('.Faq__Item').toggleClass('active');
    })


});